import { logger } from '@getvim/vim-connect-logger';
import { FreeTextInput, FreeTextType, QueryFreeTextResult } from '../../../graphql';
import { getFreeTextGQLQuery } from '../api/freeTextQuery';
import { FreeTextResult, SearchQueryPayload } from './types';

const vimConnectLogger = logger.scope('Vim Connect');

const queryFreeText = async (input: FreeTextInput) => {
  return getFreeTextGQLQuery(input);
};

const formatFreeTextResult = (
  result: QueryFreeTextResult,
  searchType: FreeTextType,
): FreeTextResult[] => {
  const results: FreeTextResult[] = [];
  try {
    result.suggestions[searchType].forEach((option) => {
      option.filters.forEach(({ value: { taxonomyCode, taxonomyDisplayName } }) =>
        results.push({
          taxonomyCode,
          taxonomyDisplayName,
        }),
      );
    });
  } catch (error) {
    vimConnectLogger.error('Failed to parse free text response', { error, response: result });
    throw error;
  }
  return results;
};

export const getFreeTextQuery = async (
  payload: SearchQueryPayload,
): Promise<FreeTextResult[] | undefined> => {
  vimConnectLogger.info('Got free text query', { payload });

  const { freeText, type } = payload;
  if (!freeText) return undefined;

  try {
    const results = await queryFreeText({ freeText, types: [type] });
    const formattedData = formatFreeTextResult(results, type);
    vimConnectLogger.info('Finished search query', { formattedData, results });

    return formattedData;
  } catch (error) {
    vimConnectLogger.error('Failed to preform free text query', { error, payload });
    return undefined;
  }
};
